import { getLmsCourseOverviewRoute } from "@/components/lms/lms.utils";

export function buildTuitionTodoOpenCourseUrl(
  courseId: string,
  currentSubdomain: string,
): string {
  const path = getLmsCourseOverviewRoute("learner", courseId);
  if (currentSubdomain === "portal") {
    return path;
  }
  const { protocol, hostname, port } = window.location;
  const hostParts = hostname.split(".");
  if (hostParts.length < 2) {
    const portSegment = port ? `:${port}` : "";
    return `${protocol}//${hostname}${portSegment}${path}`;
  }
  hostParts[0] = "portal";
  const portSegment = port ? `:${port}` : "";
  return `${protocol}//${hostParts.join(".")}${portSegment}${path}`;
}
